import { Injectable } from '@angular/core';
import { AlertRule, AlertTarget } from '../../types/alert-rule.type';
import { BaseApiService } from './base-api.service';

@Injectable({ providedIn: 'root' })
export class AlertRulesApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/alert-rules`;
  }

  async getAlertRules(): Promise<AlertRule[]> {
    return await this.get<AlertRule[]>('');
  }

  async createAlertRule(alertRule: AlertRule): Promise<void> {
    return await this.post('', alertRule);
  }

  async updateAlertRule(alertRule: AlertRule): Promise<void> {
    return await this.put('', alertRule);
  }

  async updateAlertTargets(id: string, targets: AlertTarget[]): Promise<void> {
    return await this.patch(`${id}/targets`, targets);
  }

  async deleteAlertRule(id: string): Promise<void> {
    return await this.delete(id);
  }
}
